
function checkImageClearness(context, width, height) {
   const imageData = context.getImageData(0, 0, width, height)
   const data = imageData.data
   let sum = 0
   let sumSq = 0

   for (let i = 0; i < data.length; i += 4) {
      // Luminance calculation
      const luminance = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2]
      sum += luminance
      sumSq += luminance * luminance
   }

   const mean = sum / (width * height)
   const variance = sumSq / (width * height) - mean * mean
   const sharpness = Math.sqrt(variance)

   return sharpness
}

function getImageResolution(file) {
   return new Promise((resolve) => {
      const img = new Image()
      const reader = new FileReader()

      reader.onload = (e) => {
         img.src = e.target.result
      }

      img.onload = () => {
         resolve({
            width: img.width,
            height: img.height
         })
      }

      reader.readAsDataURL(file)
   })
}

function convertHeicToJpeg(file) {
   return new Promise((resolve, reject) => {
     heic2any({ blob: file, toType: 'image/jpeg' })
       .then(resultBlob => {
         const fileName = file.name.replace(/\.[^/.]+$/, '.jpg')
         const convertedFile = new File([resultBlob], fileName, { type: 'image/jpeg' })
         resolve(convertedFile)
       })
       .catch(reject)
   })
 }

function convertBlobToBase64(blob) {
   return new Promise((resolve, reject) => {
     const reader = new FileReader()
     reader.onloadend = () => {
       const base64String = reader.result.split(',')[1] // Remove the data URL prefix
       resolve(base64String)
     }
     reader.onerror = reject
     reader.readAsDataURL(blob)
   })
 }

export default {
   checkImageClearness,
   getImageResolution,
   convertHeicToJpeg,
   convertBlobToBase64
}

